<template>
  <TenderDetail :tender="tender" :getTender="getTender" type="myDraftBidsTender" />
</template>

<script>
import MyBidsTenderDetail from './MyBidsTenderDetails'
import Vue from 'vue'

export default Vue.extend(MyBidsTenderDetail)
</script>
